module.exports = __webpack_public_path__ + "img/simplified_dark.dc08b0c.svg";